import { Stack } from '@mui/system';
import React, { useState } from 'react';
import Loading from './Loading';

import { Stage, Layer, Rect, Transformer, Text, Image, Group } from 'react-konva';
import { Button } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { useDownloadTemplateQuery } from '../features/templates/templateSlice';
import URLImage from './URLImage';
import { useDownloadProductImageQuery } from '../features/products/skuImageSlice';
import { useGetTemplateQuery } from '../features/model/templateSlice';

// Also from a konva example (for react + transform)
const PhotoAligner = ({ shapeProps, isSelected, onSelect, onChange }) => {
    const shapeRef = React.useRef();
    const trRef = React.useRef();
  
    React.useEffect(() => {
      if (isSelected && trRef.current) {
        // we need to attach transformer manually
        trRef.current.nodes([shapeRef.current]);
        trRef.current.getLayer().batchDraw();
      }
    }, [isSelected]);

    console.log(shapeProps);
  
    return (
      <React.Fragment>
        <Group
          onClick={onSelect}
          onTap={onSelect}
          ref={shapeRef}
          {...shapeProps}
          draggable
          onDragEnd={(e) => {
            onChange({
              ...shapeProps,
              x: e.target.x(),
              y: e.target.y(),
            });
          }}
          onTransformEnd={(e) => {
            // transformer is changing scale of the node
            // and NOT its width or height
            // but in the store we have only width and height
            // to match the data better we will reset scale on transform end
            const node = shapeRef.current;
            const scaleX = node.scaleX();
            const scaleY = node.scaleY();
  
            // we will reset it back
            node.scaleX(1);
            node.scaleY(1);
            onChange({
              ...shapeProps,
              x: node.x(),
              y: node.y(),
              // set minimal value
              width: Math.max(5, node.width() * scaleX),
              height: Math.max(node.height() * scaleY),
            });
          }}
        >
            <Rect width={shapeProps.width} height={shapeProps.height} stroke={shapeProps.stroke} />
        </Group>
        {isSelected && (
          <Transformer
          anchorSize={7}
            ref={trRef}
            boundBoxFunc={(oldBox, newBox) => {
              // limit resize
              if (newBox.width < 5 || newBox.height < 5) {
                return oldBox;
              }
              return newBox;
            }}
          />
        )}
      </React.Fragment>
    );
};

function createRectangle(w, h, extents, image_meta, scale) {
  return {
    x: ((w * 96.0 / 2.0) - extents.width / 2.0 + image_meta.x) * scale,
    y: ((h * 96.0 / 2.0) - extents.height / 2.0 + image_meta.y) * scale,
    width: extents.width * image_meta.scale * scale,
    height: extents.height * image_meta.scale * scale,
    img_width: extents.width,
    img_height: extents.height,
    temp_width: w,
    temp_height: h,
    used_scale: scale,
    meta_scale: {x: image_meta.scale, y: image_meta.scale},
    angle: image_meta.angle,
    stroke: "red"
  }
}

const AlignmentEditor = ({product, side, skuimage}) => {
    let template_id = (side === "front") ? product.front_template : product.back_template;
    const { data: template, error: templateError, isLoading: loadingTemplate} = useGetTemplateQuery(template_id);
    const { data: templateSVG, error, isLoading} = useDownloadTemplateQuery({name: (!template ? "" : template.svg_source)}, {skip: (!template)})
    const { data: imagedata, error: imageError, isLoading: imageLoading} = useDownloadProductImageQuery(
      {skuimage_id: skuimage.id},
      {skip: (!skuimage || !template_id)}
    );

    const [refreshed, setRefreshed] = useState(false);
    const max_width = 280;
    const dpi = 96.0;
    const aspect = template ? template.width / template.height : 1.0;
    const width = max_width;
    const height = max_width / aspect + 10;
    const [scale, setScale] = useState(template ? width / dpi / template.width : 1.0);
    const image_meta_str = skuimage.metadata.replaceAll("'", "\"");
    const image_meta = JSON.parse(image_meta_str);
    const [extents, setExtents] = useState({"width": 1.0, "height": 1.0})
    const [rect, setRect] = useState(createRectangle(template.width, template.height, extents, image_meta["alignment"], scale));

    function feedExtents(width, height) {
      setExtents({"width": width, "height": height})
      let newRect = createRectangle(template.width, template.height, {"width": width, "height": height}, image_meta["alignment"], newScale);
      setRect(newRect);
      console.log(newRect);

    }

    var newScale = template ? width / dpi / template.width : 1.0;
    if (newScale !== scale) {
        setScale(newScale);
        let newRect = createRectangle(template.width, template.height, extents, image_meta["alignment"], newScale);
        setRect(newRect);
    }
    if (isLoading || imageLoading) {
      return <Loading />;
    }
    if (error || imageError) {
      return <div>Error: {error.error}</div>
    }
    const svgdata = "data:image/svg+xml;utf8,"+encodeURIComponent(templateSVG);

    return <Stage width={width} height={height} style={{marginTop: 10, marginBottom: 10, backgroundColor: "#333333"}} key="stage">
        <Layer>
          <URLImage src={imagedata} width={rect.width} height={rect.height} x={rect.x} y={rect.y} id="template_img" onExtents={feedExtents} />
        </Layer>
        <Layer>
          <URLImage src={svgdata} width={template.width * scale} height={template.height * scale} id="template_preview"  flipped={template.flipped} />
        </Layer>
        <Layer>
            <PhotoAligner
              shapeProps={rect}
              isSelected={true}
              onChange={(newAttrs) => {
                
              }}
              onSelect={() => {
              }}/>
        </Layer>
      </Stage>
}


export default AlignmentEditor;
